import React from 'react';
import PropTypes from 'prop-types';
import {
  ToolFilled,
  ExclamationCircleTwoTone,
  InfoCircleTwoTone,
} from '@ant-design/icons';
import moment from 'moment';

const { ReactorType } = require('../../../utils/types');

function StatusIndicator(props) {
  const { status } = props;
  const style = { fontSize: 16 };
  switch (status) {
    case 'PLANNED_STOP':
      return <ToolFilled style={{ ...style, color: '#404040' }} />;
    case 'UNPLANNED_REDUCTION':
    case 'AUTO_STOP':
      return <ExclamationCircleTwoTone twoToneColor="red" style={style} />;
    case 'PLANNED_REDUCTION':
      return <InfoCircleTwoTone style={style} />;
    default:
      return null;
  }
}
StatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
};

function ReactorIndicator(props) {
  const { reactor, currentDate } = props;
  const prods = reactor.dayProductions;
  const hourIndex = moment(currentDate).hours();
  const lastIndex = reactor.dayProductions.reduce(
    (last, v, i) => (v.value === null ? last : i),
    0,
  );

  const index = Math.min(lastIndex, hourIndex);
  const currentProd = prods[index];
  const hasData = currentProd !== undefined
  const absLoad = Math.max(0, currentProd?.value);
  const part = Math.floor((absLoad / reactor.netPower_MW) * 100);

  return (
    <div
      className="ReactIndicator"
      aria-label={`Reactor ${reactor.reactorIndex} - ${
        reactor.status
      } - ${Math.floor(absLoad)} MW`}
      style={{
        background: `linear-gradient(0deg, #26a65b 0%, #26a65b ${hasData ? part : 0}%, rgba(255,255,255,1) ${hasData ? part : 0}%)`,
      }}
    >
      <div className="ReactIndicator__number">{reactor.reactorIndex}</div>
      <div className="ReactIndicator__prod">
        <strong>{hasData ? Math.floor(absLoad) : '?'}</strong>
      </div>
      <div className="ReactIndicator__status">
        <StatusIndicator status={reactor.status} />
      </div>
    </div>
  );
}

ReactorIndicator.propTypes = {
  reactor: ReactorType.isRequired,
  currentDate: PropTypes.string.isRequired,
};

export default ReactorIndicator;
